module.exports = __webpack_public_path__ + "img/step1.2ee358fd.png";